import type { ColumnDef } from "@tanstack/react-table"
import type { IAccountPayableBillHistory } from "@apis/accounts/types"
import { DateCell } from "@utils/table/columnFactories"

export const historyColumns: ColumnDef<IAccountPayableBillHistory>[] = [
  {
    accessorKey: "check_status",
    header: "Status",
  },
  {
    accessorKey: "note",
    header: "Note",
  },
  {
    accessorKey: "created_at",
    header: "Change Date",
    cell: (props) => <DateCell {...props} />,
  },
]
